/*!
 * @Author: leo
 * @Date: 2019-12-31 11:30:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-31 11:30:00
 * @Instruduction: 过滤器
 */

// Filter to uppercase the first character
export const uppercaseFirstChar = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export const parseTime = (time?: object | string | number, cFormat?: string): string | null => {
    if (time === undefined) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}'
    let date: Date
    if (typeof time === 'object') {
        date = time as Date
    } else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time)
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj: { [key: string]: number } = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return timeStr
}

/**
 * 把时间格式化为“n分钟前”、“n小时前”、“n天前”、“n个月前”的格式，
 * 如果时间在一年以前，则格式化为“yyyy年M月d日”格式
 * @method iFormatDate
 * @param {Date} date 要格式化的时间
 * @return {String} 格式化结果
 */
export const iFormatDate = (date: string) => {
    const dateTime: any = new Date(date.replace(/-/g, '/'))
    const timespan = ((new Date() as any) - dateTime) / 1000
    if (timespan < 365 * 24 * 60 * 60) {
        let result = ''
        if (timespan < 60) {
            result = '1分钟前'
        } else if (timespan < 60 * 60) {
            result = parseInt((timespan / 60).toString()) + '分钟前'
        } else if (timespan < 60 * 60 * 24) {
            result = parseInt((timespan / (60 * 60)).toString()) + '小时前'
        } else if (timespan < 60 * 60 * 24 * 30) {
            result = parseInt((timespan / (60 * 60 * 24)).toString()) + '天前'
        } else {
            result = parseInt((timespan / (60 * 60 * 24 * 30)).toString()) + '个月前'
        }
        return result
    } else {
        return dateTime.getFullYear() + '-' + (dateTime.getMonth() + 1) + '-' + dateTime.getDate()
    }
}

/**
 * format the tags to string
 * @param {array} tags
 * @returns {string | null}
 */
export const formatTags = (tags: any) => {
    if (tags.length === 0) return ''
    let tagsStr = ''
    tags.map((tag: string, index: number) => {
        if (index !== tags.length - 1) { 
            tagsStr += tag + '丨' 
        } else {
            tagsStr += tag
        }
    })
    return tagsStr
}

/**
 * 把数字格式化为千分位形式
 * @method toThousands
 * @param {number} num 要格式化的数字
 * @return {string} 千分位形式的数字
 */
export const toThousands = (num: number | string) => {
    let result = ''
    num = (num || 0).toString()
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result
        num = num.slice(0, num.length - 3)
    }
    if (num) { result = num + result }
    return result
}

/**
 * 当数字小于10万时，返回带千分位的数字；
 * 当数字大于等于10万小于一亿时，返回以万为单位的数字；
 * 当数字大于等于一亿时，返回以亿为单位的数字
 * @method formatNumber
 * @param {Number} num 要格式化的数字
 * @return {String} 格式化后的数字
 */
export const formatNumber = (num: number) => {
    num = Number(num)
    if (isNaN(num)) { return num }
    return num < 100000 ? toThousands(num)
        : (num < 100000000 ? (num / 10000).toFixed(1) + '万' : (num / 100000000).toFixed(1) + '亿')
}
